// extracted by mini-css-extract-plugin
export var activeCategoryButton = "whatsnew-module--activeCategoryButton--b222a";
export var categoryFilter = "whatsnew-module--categoryFilter--d5441";
export var eventPage = "whatsnew-module--eventPage--2fefb";
export var grid = "whatsnew-module--grid--488a5";
export var title = "whatsnew-module--title--228bc";